// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".st2[data-v-77cc91ea] {\n  fill: #fff\n}\n.st72[data-v-77cc91ea] {\n  fill: #f7a4a3\n}\n.st73[data-v-77cc91ea] {\n  fill: #cf6b7b\n}\n", ""]);
// Exports
module.exports = exports;
